module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/poster-11-aba4e377d7e86a195d1f219138a54648.jpg";